import { AxiosError, MapResponseFn } from "@eco/client";
import { ViewTpSearch } from "@eco/client";
import { useEcoClient } from "hooks";
import md5 from "md5";
import { useCallback, useMemo } from "react";
import { UseEcoQuery, useEcoQuery } from ".";
import { UseEcoQueryOptions } from "./useEcoQuery";

/**
 * 
 * Custom hooks to perform data query from backend using ViewTp https://redmine.ecomundo.tech/projects/it/wiki/ViewTP_Format_25
 * 
 * TData: Data expected from the hooks
 * TRawData: Data returned from the backend
 * 
 */
export const useViewTpSearch = <TData, TRawData = unknown>(
        query: ViewTpSearch,
        mapResponseFn?: MapResponseFn<TData, TRawData>,
        config?: UseEcoQueryOptions<unknown, TData, AxiosError>
    ): UseEcoQuery<TData, AxiosError> => {

    const ecoClient = useEcoClient();
    
    const cacheKey = useMemo(() => `View-tp${ md5(JSON.stringify(query))}`, [query])

    const queryFn = useCallback( async (): Promise<TData> => {
        return ecoClient.viewTp<TData, TRawData>(query, mapResponseFn)
    }, [query])
    
    // call react-query with name of the query class as cache name
    return useEcoQuery<TData>(cacheKey, queryFn, { enabled: query !== undefined, ...config})
}
